Vue.component('three-login', {
    delimiters: ['${','}'],
    data() {
        return {
            pathname: this.getPage(), //判断当前是不是登录注册页
        }
    },
    props: {
        act_id: { type: Number, default: 0 },
        fbKey: { type: String, required: true },
        twKey: { type: String, required: true },
        errmsgCall: Function, //错误提示回调事件
        successCall: Function  //登录注册页回调父组件表单提交
    },
    template: 
    `<div id="three-login">
        <img @click="threeAction('facebook')"
            src="https://cdn.shopify.com/s/files/1/0122/9085/0916/files/1247.png?v=1575957476" alt="Fb">
        <img @click="threeAction('twitter')"
            src="https://cdn.shopify.com/s/files/1/0122/9085/0916/files/1248.png?v=1575957476" alt="Tw">
    </div>`,
    mounted() {
        this.netInit()
    },
    methods: {
        /* 初始化 */
        netInit() {
            hello.init({
                'twitter': this.twKey,
                'facebook': this.fbKey
            }, {scope: 'email', redirect_uri: window.location.origin + window.location.pathname})

            if (this.isFB() && window.sessionStorage.getItem('loginKey')) {
                this.createPop()
                this.getMeInfo('facebook')
			}
        },
        /* 获取当前页面 */
        getPage() {
            const path = window.location.pathname || ''
            let pathname = ''
            if (/login/i.test(path)) {
                pathname = 'login'
            } else if (/register/i.test(path)) {
                pathname = 'register'
            }
            return pathname
        },
        /* 是否在facebook客服端 */
        isFB() {
            var ua = navigator.userAgent || navigator.vendor || window.opera
			return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1)
        },
        /* 开始登陆 */
        threeAction(app) {
            this.createPop()
            window.sessionStorage.setItem('loginKey', true)
            hello.login(app, { scope: 'email'}).then(() => {
                this.getMeInfo(app)
            }).catch(err => {
                this.removePop()
            })
        },
        /* 调用hello api */
        getMeInfo(app) {
            window.sessionStorage.removeItem('loginKey')
            hello(app).api('/me', { 'include_email': true }).then((response) => {
                if (!response) return
				this.mediaLogin(response, app); //调用登录接口
			}).catch(e => {
				this.removePop()
			})
        },
        /* 请求媒体注册接口 */
        mediaLogin(response, app) {
            let data = {
                act_id: this.act_id,
                account: response.email || '',
                first_name: response.first_name,
                last_name: response.last_name,
                id: response.id,
                is_true: 1,
                login_source: app,
                source: app == 'twitter' ? 10 : 9,
                invite_code: window.plugin.getEaQuerysString()['invite_code'] || ''
			}
			if (data.account && data.account.indexOf('@') > -1) {
				// account = data.account
			} else {
				data.account = data.id + '_0_#' + (data.login_source == 'facebook' ? 'fb@ilitom.com' : 'tw@ilitom.com')
				data.is_true = 0
            }
            window.plugin.ajax('/api/shop/social/media/login', data).then(res => {
                var password = '';
				if (res.code == 1) {
					if (res.data.is_default) {
						// 拼接密码
						let key = `8${data.account}${data.login_source}md5sat${res.data.rand_key}`;
						let md_key = md5(key);
						// 取前面6位  和后面 3位
						password = md_key.substring(0, 6) + data.account.substring(0, 3);
					} else {
						let key = window.atob(res.data.password);
                        password = key.substring(12, key.length - 50);
					}
                    this.shopifyLogin({account: data.account, password})
                } else {
                    this.removePop()
                    this.errmsgCall(res.msg, this.pathname)
                }
            }).catch(err => {
                this.removePop()
                this.errmsgCall('Network anomaly', this.pathname)
			})
        },
        /* 登陆shopify */
        shopifyLogin(formData) {
            // 调用登录方法
			window.plugin.login(formData).then(() => {
				this.successCall(this.pathname) //成功回调
			}).catch(msg => {
				this.removePop()
				this.errmsgCall(msg)
			})
        },
        /* 创建遮罩 */
        createPop() {
            var layer = document.createElement('div');
            layer.className = 'bgy_mask';
            var img = new Image();
            img.src = "https://cdn.shopify.com/s/files/1/1769/5297/files/ZZ5H.gif?60115";
            img.className = 'bgy_img';
            layer.appendChild(img);
            document.body.appendChild(layer);
        },
        /* 清除遮罩 */
        removePop() {
            var layer = document.querySelector(".bgy_mask");
            if(!layer) return;
            document.body.removeChild(layer);
        }
    }
})